const blocks = document.querySelectorAll('.block--bin-sizes')
blocks.forEach(block => {

    const site_id = parseInt(block.dataset.location)

    if (!window.kpa?.locations) {
        return
    }

    const sites = window.kpa.locations.filter(l => parseInt(l.id) === site_id)

    if (sites.length === 0) {
        return
    }

    const site = sites[0]

    const products = site.products.map(p => {
        return {
            title: p.title, size: p.fields.size, price: p.price, quantity: 1,
        }
    })

    if (window.analytics && products.length > 0) {
        analytics.track("Product List Viewed", {
            affiliation: site.location_name, list_id: document.title, products: products
        })
    }


})